import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Target, Users, Building2, Cog, CheckCircle2 } from 'lucide-react';
import { Button } from '../ui/button';
import { aboutContent } from '../../data/mock';

const AboutPage = () => {
  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="relative py-24 bg-[#242726]">
        <div className="container-custom">
          <div className="max-w-3xl">
            <span className="caption text-[#c4291c] mb-4 block">Qui sommes-nous</span>
            <h1 className="heading-1 text-white mb-6">
              {aboutContent.title}
            </h1>
            <p className="body-large text-white/70">
              {aboutContent.paragraphs[0]}
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="section-padding bg-[#1a1c1b]">
        <div className="container-custom">
          <div className="grid lg:grid-cols-2 gap-16 items-start">
            {/* Left Column - Story */}
            <div>
              <div className="prose prose-lg">
                {aboutContent.paragraphs.map((paragraph, index) => (
                  <p key={index} className="text-white/70 body-large mb-6">
                    {paragraph}
                  </p>
                ))}
              </div>

              {/* Image */}
              <div className="mt-10 rounded-2xl overflow-hidden">
                <img
                  src={aboutContent.image}
                  alt="PREBATI Production Facility"
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>

            {/* Right Column - Objectives & Positioning */}
            <div className="lg:sticky lg:top-28">
              {/* Objectives */}
              <div className="bg-[#2a2d2c] rounded-2xl p-8 mb-8 border border-white/10">
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-10 h-10 rounded-xl bg-[#c4291c]/10 flex items-center justify-center">
                    <Target className="w-5 h-5 text-[#c4291c]" />
                  </div>
                  <h3 className="heading-3 text-white">Nos objectifs</h3>
                </div>
                <ul className="space-y-4">
                  {aboutContent.objectives.map((objective, index) => (
                    <li key={index} className="flex items-start gap-3">
                      <CheckCircle2 className="w-5 h-5 text-[#c4291c] mt-0.5 flex-shrink-0" />
                      <span className="text-white/70 body-medium">{objective}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Positioning */}
              <div className="space-y-4">
                <h3 className="heading-3 text-white mb-6">Notre positionnement</h3>
                {aboutContent.positioning.map((item, index) => (
                  <div
                    key={index}
                    className="bg-[#2a2d2c] rounded-xl p-6 border border-white/10 card-hover"
                  >
                    <h4 className="text-white font-semibold mb-2">{item.title}</h4>
                    <p className="text-white/60 body-small">{item.description}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Partners Section */}
      <section className="section-padding bg-[#242726]">
        <div className="container-custom">
          <div className="text-center mb-12">
            <span className="caption text-[#c4291c] mb-4 block">Partenariat</span>
            <h2 className="heading-2 text-white mb-6">
              Une collaboration stratégique
            </h2>
            <p className="body-large text-white/60 max-w-2xl mx-auto">
              PREBATI est le fruit d'un partenariat entre ECOBATI et OTEP France, combinant expertise locale et technologie internationale.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            <div className="bg-[#1a1c1b] rounded-2xl p-8 border border-white/10">
              <div className="w-12 h-12 rounded-xl bg-[#c4291c]/10 flex items-center justify-center mb-6">
                <Building2 className="w-6 h-6 text-[#c4291c]" />
              </div>
              <h3 className="heading-3 text-white mb-4">ECOBATI</h3>
              <p className="text-white/60 body-medium">
                Partenaire local mauritanien apportant la connaissance du marché et l'ancrage territorial pour une production adaptée aux besoins régionaux.
              </p>
            </div>

            <div className="bg-[#1a1c1b] rounded-2xl p-8 border border-white/10">
              <div className="w-12 h-12 rounded-xl bg-[#c4291c]/10 flex items-center justify-center mb-6">
                <Cog className="w-6 h-6 text-[#c4291c]" />
              </div>
              <h3 className="heading-3 text-white mb-4">OTEP France</h3>
              <p className="text-white/60 body-medium">
                Licencié français fournissant la technologie éprouvée du béton précontraint, utilisée avec succès à l'international depuis des décennies.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-[#1a1c1b] border-t border-white/10">
        <div className="container-custom">
          <div className="flex flex-col md:flex-row items-center justify-between gap-8">
            <div>
              <h3 className="heading-3 text-white mb-2">
                Vous avez un projet de construction ?
              </h3>
              <p className="text-white/60 body-medium">
                Découvrez comment PREBATI peut vous accompagner.
              </p>
            </div>
            <a href="https://wa.me/22243111616?text=" target="_blank" rel="noopener noreferrer">
              <Button className="btn-primary">
                Demander un devis
                <ArrowRight className="w-4 h-4" />
              </Button>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
